// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'factory';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M10.24 12.357v-4.27a.709.709 0 0 0-1.127-.575L5.635 10.41V8.086a.708.708 0 0 0-1.126-.574l-3.187 2.684a.708.708 0 0 0-.29.572v6.194h15.937v-3.896a.709.709 0 0 0-.709-.709zm3.187-11.234a4.91 4.91 0 0 0-2.121.44c-5.263 2.246-7.438-.525-7.438-.525' />
    <path d='m15.906 12.358-.708-8.855h-2.125l-.708 8.855M5.99 15.19a1.417 1.417 0 0 0-2.834 0v1.772H5.99zm2.833 0a1.417 1.417 0 0 0-2.833 0v1.772h2.833zm2.479-.53h.708m2.125 0h.709' />
  </g>
);

export const viewBox = '0 0 18 18';
